<template>
  <div class="calendar-week-box">
    <div class="calendar-week">
      <div class="calendar-head">
        <div class="calendar-daily-intervals"></div>
        <div class="head-day" v-for="(item, index) in allDataWeek" :key="index">
          <div>{{ changeDateGetMonthDay(item.title) }}</div>
          <div class="head-day">{{ weekTitle[dayjs(item.title).day()] }}</div>
        </div>
      </div>
      <div class="calendar-body">
        <div class="calendar-intervals-body">
          <div class="calendar-intervals">
            <div class="calendar-intervals-text-first">00:00</div>
            <div class="calendar-intervals-text">04:00</div>
          </div>
          <div class="calendar-intervals">
            <div class="calendar-intervals-text">08:00</div>
          </div>
          <div class="calendar-intervals">
            <div class="calendar-intervals-text">12:00</div>
          </div>
          <div class="calendar-intervals">
            <div class="calendar-intervals-text">16:00</div>
          </div>
          <div class="calendar-intervals">
            <div class="calendar-intervals-text">20:00</div>
          </div>
          <div class="calendar-intervals">
            <div class="calendar-intervals-text">24:00</div>
          </div>
        </div>
        <div class="calendar-day" v-for="(item, index) in allDataWeek" :key="index">
          <div class="calendar-day-intervals"></div>
          <div class="calendar-day-intervals"></div>
          <div class="calendar-day-intervals"></div>
          <div class="calendar-day-intervals"></div>
          <div class="calendar-day-intervals"></div>
          <div class="calendar-day-intervals calendar-day-intervals-last"></div>
          <div class="timed-container" v-if="item.children.length > 0">
            <div
              class="timed"
              v-for="(timeItem, timeIndex) in item.children"
              :key="timeIndex + timeItem.mode"
              :style="{
                top: timeItem.top + 'px',
                height: timeItem.height + 'px',
                width: timeItem.width + 'px',
                background: timeItem.color,
                left: timeItem.left + 'px'
              }"
            >
              <a-popover :title="timeItem.title" trigger="click">
                <template #content>
                  <p>{{ t('home.rqp3ld') }}：{{ timeItem.customerName || '--' }}</p>
                  <p>{{ t('home.agy27l') }}：{{ timeItem.contactName || '--' }}</p>
                  <p>{{ t('home.rzzoit') }}：{{ timeItem.startTime || '--' }}</p>
                  <p>{{ t('home.ld71ju') }}：{{ timeItem.mode || '--' }}</p>
                  <p>{{ t('home.5afs7f') }}：{{ timeItem.purpose || '--' }}</p>
                </template>
                <span>
                  <!-- <span v-if="timeItem.height > 22">{{ timeItem.title }}</span>
                  <span v-else>_</span> -->
                </span>
              </a-popover>
            </div>

            <div
              class="current-time"
              :class="item.title == dayjs().format('YYYY/MM/DD') ? 'current-time-first' : ''"
              v-if="nowWeek.findIndex((weekitem:any)=>weekitem===item.title)===-1?false:true"
              :style="{ top: nowDate + 'px' }"
            ></div>
          </div>
          <div class="timed-container" v-else>
            <div
              class="current-time"
              :class="item.title == dayjs().format('YYYY/MM/DD') ? 'current-time-first' : ''"
              v-if="nowWeek.findIndex((weekitem:any)=>weekitem===item.title)===-1?false:true"
              :style="{ top: nowDate + 'px' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import { computed, defineComponent, PropType, ref, watch } from 'vue'
import { cloneDeep } from 'lodash-es'
// import { getHomePageVisitPlan } from '@/api/gucangSales/index'
import type { HomePageVisitPlan } from '@/typings/api/index'
import { useInteractionStore } from '@/stores/interaction'
export default defineComponent({
  props: {
    selectValue: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    allData: {
      type: Array as PropType<HomePageVisitPlan>,
      default: () => []
    }
  },
  setup(props) {
    const { t } = useI18n()
    const week = ref<string[]>([])
    const weekTitle = computed(() => {
      return [
        t('home.uehgmc'),
        t('home.qi07xg'),
        t('home.976l4e'),
        t('home.lq7ml7'),
        t('home.gudsu8'),
        t('home.s8l1yd'),
        t('home.rjgtjf')
      ]
    })
    watch(
      () => props.selectValue,
      (newValue) => {
        week.value = newValue
        haveNotePushIntoArr(week.value, allHaveNoteDate.value)
      },
      {
        deep: true
      }
    )
    const allDataF = ref()
    watch(
      () => props.allData,
      () => {
        allDataF.value = cloneDeep(props.allData)
        // haveNotePushIntoArr(week.value, allHaveNoteDate.value)
        getData()
      },
      {
        deep: true
      }
    )
    const BackDataChange = (arr: HomePageVisitPlan[]) => {
      const newArr: any = []
      if (arr && arr.length > 0) {
        arr.forEach((item: any) => {
          if (item.list.length > 0) {
            item.list.forEach((itemI: any) => {
              itemI.visitDate = item.date
              newArr.push(itemI)
            })
          }
        })
      } else {
        return []
      }
      return newArr
    }
    const getData = async () => {
      try {
        // const res:any = await getHomePageVisitPlan({
        //   startTime: `${week.value[0]} 00:00:00`,
        //   endTime: `${week.value[6]} 23:59:59`
        // })
        allHaveNoteDate.value = BackDataChange(allDataF.value)
        haveNotePushIntoArr(week.value, allHaveNoteDate.value)
      } catch (error) {
        console.log('getData error: ', error)
      }
    }
    const value = ref()
    const nowDate = (dayjs().hour() * 60 + dayjs().minute()) * 0.1583
    const allHaveNoteDate = ref<any>([
      // {
      //   visitDate: '2022/07/11',
      //   startTime: '2022/07/11 08:00:00',
      //   endTime: '2022/07/11 12:00:00',
      //   title: '周会',
      //   content: '这是周一的周会',
      //   contactName: '联系人xxx',
      //   customerName: '客户xxx',
      //   purpose: '拜访目的xxx',
      //   mode: '拜访方式xxx'
      // }
    ])
    const allDataWeek: any = ref([])
    const haveNotePushIntoArr = (week: any, allHaveNote: any) => {
      allDataWeek.value = []
      week.forEach((item: any) => {
        // arr为满足当天的所有纪要合集
        const arr = allHaveNote.filter((itemHave: any) => itemHave.visitDate === item)

        if (arr.length === 0) {
          allDataWeek.value.push({
            title: item,
            children: []
          })
        } else {
          const colorArr = ['rgb(78,198,144)', '#877CED', '#36C8E1', '#FFB648']
          /* 相同初始时间 */
          arr.forEach((widthItem: any, iNum: number) => {
            // haveSameStartTimeArr 为当天时间相同的所有数据集
            const haveSameStartTimeArr = arr.filter((arrItem: any) => arrItem.startTime === widthItem.startTime)
            if (haveSameStartTimeArr.length > 1) {
              widthItem.width = 95 / haveSameStartTimeArr.length
              const index = haveSameStartTimeArr.findIndex((havesameItem: any) => havesameItem.id === widthItem.id)
              widthItem.left = (95 / haveSameStartTimeArr.length) * index

              widthItem.color = `rgba(${Math.floor(Math.random() * 255)},${Math.floor(
                Math.random() * 255
              )},${Math.floor(Math.random() * 255)},1)`
              widthItem.color = colorArr[iNum % 4]
            } else {
              widthItem.width = 95
              widthItem.color = 'rgba(29, 76, 210, 1)'
            }
          })
          arr.forEach((arrItem: any) => {
            arrItem.top = (dayjs(arrItem.startTime).hour() * 60 + dayjs(arrItem.startTime).minute()) * 0.1583
            arrItem.height =
              dayjs(arrItem.endTime).diff(dayjs(arrItem.startTime), 'minute') * 0.1583 > 228
                ? 228
                : dayjs(arrItem.endTime).diff(dayjs(arrItem.startTime), 'minute') * 0.1583
          })
          allDataWeek.value.push({
            title: item,
            children: arr
          })
        }
      })
    }
    // 获取当前时间的本周日期。进行是否显示红线对比
    const nowWeek = ref()
    const handleWeekChange = () => {
      const arr = [1, 2, 3, 4, 5, 6, 7]
      nowWeek.value = []
      const firstDay = dayjs().startOf('week')
      arr.forEach((item, index) => {
        nowWeek.value.push(dayjs(firstDay).add(index, 'day').format('YYYY/MM/DD'))
      })
    }
    handleWeekChange()
    // 切换多语言时重刷
    const shareInfo = useInteractionStore()
    watch(shareInfo, () => {
      handleWeekChange()
    })
    const changeDateGetMonthDay = (date: string) => {
      if (date) {
        const arr = date.split('/')
        return arr.length > 0 ? `${arr[1]}/${arr[2]}` : ''
      }
    }
    return {
      t,
      value,
      weekTitle,
      nowDate,
      week,
      dayjs,
      allDataWeek,
      nowWeek,
      changeDateGetMonthDay
    }
  }
})
</script>
<style lang="scss" scoped>
.calendar-week-box {
  padding: 0 44px;
  .calendar-week {
    width: 100%;
    height: 297px;
    .calendar-head {
      display: flex;
      // height: 38px;
      height: 48px;
      .calendar-daily-intervals {
        width: 50px;
      }
      .head-day {
        flex: 1;
        text-align: center;

        .head-day {
          text-align: center;
        }
      }
    }
    .calendar-body {
      width: 100%;
      display: flex;
      height: 228px;
      // overflow: hidden;
      .calendar-intervals-body {
        width: 50px;
        .calendar-intervals {
          height: 38px;
          position: relative;
          .calendar-intervals-text {
            font-weight: 400;
            font-size: 12px;
            color: #727272;
            position: absolute;
            bottom: -8px;
          }
          .calendar-intervals-text-first {
            font-weight: 400;
            font-size: 12px;
            color: #727272;
            position: absolute;
            top: -8px;
          }
        }
      }
      .calendar-day {
        flex: 1;
        position: relative;
        // overflow: hidden;
        .timed-container {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          .timed {
            position: absolute;
            height: 2.375px;
            cursor: pointer;
            color: #fff;
            width: 95%;
            background-color: rgba(29, 76, 210, 0.8);
            overflow: hidden;
            span {
              width: 100%;
              height: 100%;
              padding-left: 5px;
              display: block;
            }
          }
          .current-time {
            width: 100%;
            border-bottom: 1px solid red;
            position: absolute;
            top: 20px;
          }
          .current-time-first::after {
            content: '';
            position: absolute;
            background-color: #ea4335;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-top: -5px;
            margin-left: -6.5px;
          }
        }
        .calendar-day-intervals {
          height: 38px;
          background: #f3f3f9;
          box-sizing: border-box;
          border: 1px dashed #d8dfe4;
          border-top: none;
          border-left: none;
        }
        .calendar-day-intervals-last {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
